module.exports = __webpack_public_path__ + "static/vot-section-2-bg-f0cda84b355cdb448bd702fb9c4db3d2.mp4";